import React, { useState } from "react";
import { TextField, Chip, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    border: `1px solid ${
      theme.palette.type === "dark" ? "#ffffff3b" : "#0000003b"
    }`,
    borderRadius: 4,
    padding: "6px",
    "&:hover": {
      borderColor: theme.palette.primary.main,
    },
  },
  chip: {
    margin: 4,
  },
  input: {
    flex: 1,
    minWidth: "100%",
    padding: "0 10px"
  },
}));

const CustomChipInput = ({
  value = [],
  onAdd,
  onDelete,
  label,
  placeholder,
  id,
}: any) => {
  const classes = useStyles();
  const [inputValue, setInputValue] = useState("");

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (!inputValue.trim()) return;

    if (event.key === "Enter") {
      event.preventDefault();

      if (onAdd) {
        onAdd(inputValue.trim(), id);
      }

      setInputValue("");
    }
  };

  const handleDelete = (chipToDelete: string) => {
    if (onDelete) {
      onDelete(chipToDelete, id);
    }
  };

  return (
    <div>
      {label && (
        <label style={{ fontSize: 12, opacity: 0.7 }}>{label}</label>
      )}

      <div className={classes.root}>
        {value.map((chip: string, index: number) => (
          <Chip
            key={`${chip}-${index}`}
            label={chip}
            onDelete={() => handleDelete(chip)}
            className={classes.chip}
            color="primary"
          />
        ))}

        <TextField
          id={id}
          value={inputValue}
          placeholder={placeholder}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          className={classes.input}
          InputProps={{
            disableUnderline: true,
          }}
        />
      </div>
    </div>
  );
};

export default CustomChipInput;